import React from 'react'
import { BiListPlus } from 'react-icons/bi'
import useTooltip from '../../../../hooks/useTooltip';
import './AddProperty.css'

const AddProperty = ({ onClick }) => {
  const {onMouseEnter, onMouseLeave, showTooltip} = useTooltip({  
    showDelay: 600, // milliseconds
    hideDelay: 600 // milliseconds
  });


  // --- RENDER ---

  return (
    <div className='addProperyButton' >
      <div className='addPropIcon' onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <BiListPlus />
      </div>
      <div className='addPropText'>
      </div>
      {showTooltip && (
        <div className='addPropTooltip'>
          Add Item
        </div>
      )}
    </div>
  )
}

export default React.memo(AddProperty);